export default function addOrganizationSchema() {
	const schema = {
		"@context": "http://schema.org",
		"@type": "Organization",
		name: "Launer London",
		alternateName: "Launer",
		url: "https://launer.com/",
		logo: {
			"@type": "ImageObject",
			"@id": "https://launer.com/#logo",
			url: "https://launer.com/images/logo.webp",
			width: 496,
			height: 352,
		},
		foundingDate: "1940",
		founder: {
			"@type": "Person",
			name: "Sam Launer",
		},
		brand: {
			"@type": "Brand",
			name: "Launer London",
		},
		sameAs: [
			"https://www.instagram.com/launerlondonofficial/",
			"https://www.facebook.com/launerlondonofficial",
			"https://uk.pinterest.com/launerlondon/",
		],
		description:
			"Welcome to the world of Launer and discover a British legacy built on tradition and fine craftsmanship. Celebrating 80 years of heritage, producing the very finest in understated luxury, creating structured handbags and small leather goods, employing time-honoured skills and traditions. Today Launer is recognised the world over for its iconic structured style handbags and 'twisted rope' hero signature emblem, every piece is crafted by hand in England.",
		contactPoint: {
			"@type": "ContactPoint",
			contactType: "Customer Service",
			email: "sales@launer.com",
			telephone: "+44 1883 625 562",
		},
		hasMerchantReturnPolicy: {
			"@type": "MerchantReturnPolicy",
			merchantReturnLink: "https://launer.com/returns-refunds",
			returnPolicyCategory:
				"https://schema.org/MerchantReturnFiniteReturnWindow",
			merchantReturnDays: 15,
			inStoreReturnsOffered: false,
		},
		makesOffer: [
			{
				"@type": "Offer",
				itemOffered: {
					"@type": "Product",
					name: "Structured Leather Handbag",
					brand: "Launer London",
					category: "Luxury Handbags",
					url: "https://launer.com/handbags/",
				},
			},
			{
				"@type": "Offer",
				itemOffered: {
					"@type": "Product",
					name: "Leather Luggage",
					brand: "Launer London",
					category: "Luxury Luggage",
					url: "https://launer.com/c/luggage",
				},
			},
			{
				"@type": "Offer",
				itemOffered: {
					"@type": "Product",
					name: "Leather Purses",
					brand: "Launer London",
					category: "Luxury Purses",
					url: "https://launer.com/c/purses",
				},
			},
			{
				"@type": "Offer",
				itemOffered: {
					"@type": "Product",
					name: "Men's Leather Wallets",
					brand: "Launer London",
					category: "Luxury Wallets",
					url: "https://launer.com/c/wallets",
				},
			},
			{
				"@type": "Offer",
				itemOffered: {
					"@type": "Product",
					name: "Small Leather Goods",
					brand: "Launer London",
					category: "Luxury Accessories",
					url: "https://launer.com/c/accessories",
				},
			},
		],
	};

	const script = document.createElement("script");
	script.id = "org-schema";
	script.type = "application/ld+json";
	script.innerText = JSON.stringify(schema);
	document.head.appendChild(script);

	return () => {
		document.head.querySelector("#org-schema")?.remove();
	};
}
